import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { theme } from '../../styles/theme';

interface DrawerPanelProps {
  $isOpen: boolean;
  children: ReactNode;
}

export const DrawerPanel: FC<DrawerPanelProps> = ({ $isOpen, children }) => (
  <Box
    sx={{
      background: 'white',
      boxSizing: 'border-box',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      [`@media (min-width: ${theme.breakPoints.desktop}px)`]: {
        transition: 'width 400ms ease-in-out',
        overflow: $isOpen ? 'visible' : 'hidden',
        width: $isOpen ? theme.layout.drawerWidth : '0px',
        flex: $isOpen ? 'none' : '0 0 0px',
      },
    }}
  >
    {children}
  </Box>
);
